import React, { FC } from 'react';
import { PeriodBreakdownItem, WeekBreakdownItem } from '../../../../../models/stats.models';
import { getPeriodStatus } from '../../../../../components/period-summary/period-summary.helpers';

interface LogPeriodTabsProps {
  periods: PeriodBreakdownItem[];
  weeks: WeekBreakdownItem[];
  selectedPeriodIndex: number;
  onSelectPeriod: (index: number) => void;
}

const LogPeriodTabs: FC<LogPeriodTabsProps> = ({ periods, weeks, selectedPeriodIndex, onSelectPeriod }) => (
  <div className="log-tab-bar">
    {periods.map((period) => {
      const status = getPeriodStatus(period, weeks);
      const isSelected = period.index === selectedPeriodIndex;
      const className = [
        'log-tab-btn',
        isSelected ? 'active' : '',
        !isSelected && status === 'completed' ? 'completed-period' : '',
        !isSelected && status === 'current' ? 'current-period' : '',
        !isSelected && status === 'upcoming' ? 'future-period' : '',
      ]
        .filter(Boolean)
        .join(' ');

      return (
        <button key={period.index} type="button" className={className} onClick={() => onSelectPeriod(period.index)}>
          <span className="log-tab-label">Period {period.index}</span>
          {status === 'completed' && (
            <span
              className={`log-tab-check ${isSelected ? 'log-tab-check-selected' : 'log-tab-check-completed'}`}
              aria-hidden
            >
              ✓
            </span>
          )}
          {status === 'current' && <span className="log-tab-dot" aria-hidden />}
        </button>
      );
    })}
  </div>
);

export default LogPeriodTabs;
